import { Dayjs } from 'dayjs'
import httpRequest from 'httpRequest'
import {
    CustomerAddressContract,
    CustomerListContract,
    LoyaltyHistoryContract,
    NewCustomerAddressContract,
    SearchCustomerEventType,
} from 'models'
import {
    CustomerPurchaseHistory,
    CustomerLookupContract,
    CustomerUpdateContract,
} from 'models'

const CUSTOMER_PREFIX = '/company/customers'

const customerService = {
    getCustomers: (includeDefaultAddress?: boolean) =>
        httpRequest.get<CustomerLookupContract[]>(CUSTOMER_PREFIX + '/lookup', {
            params: { includeDefaultAddress },
        }),
    getCustomerById: (customerId: string) =>
        httpRequest.get<CustomerUpdateContract>(
            `${CUSTOMER_PREFIX}/${customerId}`,
        ),
    getPOSCustomers: () =>
        httpRequest.get<CustomerListContract[]>(CUSTOMER_PREFIX),
    getCustomerSlimById: (customerId: string) =>
        httpRequest.get<CustomerLookupContract>(
            `${CUSTOMER_PREFIX}/lookup/${customerId}`,
        ),
    deleteCustomerMany: (customerIds: string[]) =>
        httpRequest.delete(CUSTOMER_PREFIX, { params: { customerIds } }),
    createCustomer: (newCustomer: CustomerUpdateContract) =>
        httpRequest.post<CustomerLookupContract>(CUSTOMER_PREFIX, newCustomer),
    updateCustomerById: (
        customerId: string,
        customer: CustomerUpdateContract,
    ) => httpRequest.put(`${CUSTOMER_PREFIX}/${customerId}`, customer),
    importCustomer: (formData: FormData) =>
        httpRequest.post(`${CUSTOMER_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    getPurchaseHistories: (
        customerID: string | undefined | null,
        startDate: Dayjs,
        endDate: Dayjs,
        locationID: string[],
        orderChannels: string[],
        saleTypes: SearchCustomerEventType[],
    ) => {
        return httpRequest.get<CustomerPurchaseHistory[]>(
            `${CUSTOMER_PREFIX}/purchase-history`,
            {
                params: {
                    customerIDs: customerID,
                    startDate: startDate?.format('YYYY-MM-DD'),
                    endDate: endDate?.format('YYYY-MM-DD'),
                    locationIDs: locationID,
                    orderChannels: orderChannels,
                    saleTypes: saleTypes,
                },
            },
        )
    },
    activateCustomer: (customerID: string) =>
        httpRequest.put<boolean>(`${CUSTOMER_PREFIX}/activate/${customerID}`),
    deactivateCustomer: (customerID: string) =>
        httpRequest.put<boolean>(`${CUSTOMER_PREFIX}/deactivate/${customerID}`),
    getLoyaltyHistories: (startDate: string, endDate: string) =>
        httpRequest.get<LoyaltyHistoryContract[]>(
            `${CUSTOMER_PREFIX}/loyalty-history`,
            {
                params: { startDate, endDate },
            },
        ),
    createCustomerAddress: (
        customerID: string,
        payload: NewCustomerAddressContract,
    ) =>
        httpRequest.post<CustomerAddressContract>(
            `${CUSTOMER_PREFIX}/${customerID}/add-address`,
            payload,
        ),
}

export default customerService
